module.exports = __webpack_public_path__ + "img/market.ef3d33d9.svg";